import classNames from 'classnames';
import React from 'react';

interface RCCardProps {
  fullHeight?: boolean;
  children: React.ReactNode;
  bgColorToken?: string;
  bgColorHoverToken?: string;
}

/**
 * RCCard is a lightweight wrapper that allows for easy implementation of a clickable card-shaped wrapper UI.
 *
 * Special consideration should be taken when using `<RCCard.LinkWrapper>` as it matters what `<a>` tag it wraps.
 *
 * Check out the [Cadence Docs for Cards](https://cadence.reverb.tools/component-library/cards) for more information.
 */
export function RCCard({
  fullHeight = false,
  children,
  bgColorToken = 'rc-color-palette-bw-white',
  bgColorHoverToken = 'rc-color-palette-gray-100',
}: RCCardProps) {
  const bgColors = {
    '--bg-color': `var(--${bgColorToken})`,
    '--bg-color-hover': `var(--${bgColorHoverToken})`,
  } as React.CSSProperties;

  return (
    <div
      className={classNames(
        'rc-card',
        {
          'rc-card--full-height': fullHeight,
        },
      )}
      style={bgColors}
    >
      {children}
    </div>
  );
}

interface RCCardLinkProps {
  children: React.ReactElement<HTMLAnchorElement>;
}

function LinkWrapper({ children }: RCCardLinkProps) {
  return React.cloneElement(children, {
    className: ['rc-card__link', children.props.className].join(' '),
  });
}

RCCard.LinkWrapper = LinkWrapper;
